<template>
  <div>
    <v-progress-linear
      :value="qyPercentage"
      :color="color"
      height="25"
      rounded
    >
      <strong
        v-if="qyPercentage == 100"
        class="green--text"
      >
        貨櫃空間充足
      </strong>
      <template v-else>
        <strong class="caption black--text">專櫃剩餘空間 {{ qyPercentage }}%</strong>
        <Tooltips>
          特快專櫃：大陸優先裝櫃，台灣優先清關。<br>
          剩餘空間 0%：仍可下單，仍有機會裝上，若滿櫃裝不上則順延下一班船搶佔最先位置。
        </Tooltips>
      </template>
    </v-progress-linear>
  </div>
</template>
<script>
export default {
  props: {
    scheduleShipment: Object,
  },
  computed: {
    qyPercentage () {
      if (this.scheduleShipment.calJySeQty <= 0) return 100
      return Math.max(0, Math.floor((1 - this.scheduleShipment.currJySeQty.stCounter / this.scheduleShipment.calJySeQty) * 100))
    },
    color () {
      if (this.qyPercentage === 0) {
        return 'grey'
      } else if (this.qyPercentage <= 5) {
        return 'deep-orange lighten-1'
      } else if (this.qyPercentage <= 20) {
        return 'orange lighten-1'
      }
      return 'white'
    },
  },
}
</script>
<style lang="postcss" scoped>
.expectedTime {
  border-top: 1px dashed #ff9800;
}
.timeNum {
  /* background: linear-gradient(#ff9947 50%, #ffb175 50%); */
  border: 1px solid rgba(167, 167, 167, 0.6);
  display: inline-block;
  line-height: 15px;
  font-weight: bold;
  padding: 0 2px;
}
</style>
